<template>
  <div>
    ABCD

    {{ categoryContent }}
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");

export default {
  name: "Category",
  data() {
    return {
    };
  },
  created() {
    const key = this.$route.params.key;
  },
  methods: {
    ...mapActions(["getCategoryContent"]),
  },
  computed: {
    ...mapState(["categoryContent", "isLoading"]),
  },
};
</script>
